/* PageHeader — title + subtitle + actions on the right. Renders flush at
   the top of every screen. Responsive: actions wrap below the title on
   small screens.

   `accent` (added later) draws a short coloured bar beside the title so
   you can tell which part of the admin you're in at a glance. Omit it and
   the header renders exactly as before.

   Accents are keyed by DOMAIN, not by individual page — that's what makes
   the colour mean something. Fifteen distinct colours would be a paint
   chart; five domains is a map:

     sales     — leads, sales team, billing, analytics   (blue)
     inventory — properties, builders, locations         (gold, the brand)
     content   — cms, blog, media, seo                   (violet)
     interior  — interior design                         (teal)
     ops       — attendance, settings, auth              (slate)

   Deliberately a thin bar rather than a tinted header background: the
   background wash competes with tinted state cards below it, and the
   whole point is that state colour stays the loudest thing on screen.

   Class strings are literal for Tailwind JIT — see the note in Card.jsx. */
const ACCENTS = {
  none:      "",
  sales:     "bg-blue-500",
  inventory: "bg-gold",
  content:   "bg-violet-500",
  interior:  "bg-teal-500",
  ops:       "bg-slate-400",
};

export function PageHeader({ title, subtitle, actions, accent = "none" }) {
  const accentCls = ACCENTS[accent] || "";
  return (
    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 sm:gap-4 mb-5 sm:mb-6">
      <div className="min-w-0 flex items-start gap-3">
        {accentCls && (
          <span aria-hidden className={`mt-1 w-1 h-8 rounded-full shrink-0 ${accentCls}`} />
        )}
        <div className="min-w-0">
          <h1 className="text-lg sm:text-xl font-semibold text-slate-900 tracking-tight">
            {title}
          </h1>
          {subtitle && (
            <p className="text-xs sm:text-sm text-slate-500 mt-0.5">{subtitle}</p>
          )}
        </div>
      </div>
      {actions && (
        <div className="flex items-center gap-2 flex-wrap sm:flex-nowrap sm:shrink-0">
          {actions}
        </div>
      )}
    </div>
  );
}
